// KPI kanıt paneli + raporlanan değer rozeti — UI kopya TEK kaynağı (M16 T18/T23, DR9).
// Bileşenlerde satır içi kanıt/raporlanan string'i yazılmaz; e2e spec'i bu nesnenin elle eşlenik
// kopyasını taşıyacaksa birini değiştirince diğerini de güncelle (kpi-ui.ts KPI_COPY kalıbı).

export const KPI_EVIDENCE_COPY = {
  tabs: {
    value: "Değer",
    evidence: "Kanıt",
    history: "Geçmiş",
  },
  panel: {
    empty: "Bu hücreye bağlı kanıt yok",
    emptyHint:
      "PDF, resim ya da Excel dosyası ekleyin; aynı dosyayı birden çok göstergeye bağlayabilirsiniz.",
    loading: "Kanıtlar yükleniyor…",
    loadError: "Kanıtlar yüklenemedi",
    add: "+ Kanıt ekle (PDF, resim, Excel)",
    addNew: "Yeni dosya yükle",
    addExisting: "Müşterinin mevcut dosyasını bağla",
    existingEmpty: "Bu müşteride yüklenmiş dosya yok",
    existingSearch: "Dosya ara…",
    open: "Aç",
    openBlocked: "Dosya taranmadan açılamaz",
    unlink: "Bağı kaldır",
    linkedTo: "bağlı:",
    linkedBy: "kanıt",
    importSource: "kaynak dosya (içe aktarma)",
    cancel: "Vazgeç",
    retryUpload: "Yeniden dene",
    uploadHint: "En fazla 50 MB · PDF, JPG, PNG, WEBP, XLSX, XLS, DOCX, CSV",
    pickLabel: "Dosya seç",
    uploading: "Yükleniyor…",
    uploadFailed: "Yükleme başarısız",
    linkFailed: "Bağ kurulamadı",
    unlinkFailed: "Bağ kaldırılamadı",
    linked: (n: number) => `${n.toString()} hücreye bağlandı`,
    // TODO-EVIDENCE-01 — form kanıtı rozeti (aynı dosya form sorusuna da bağlı)
    formEvidence: (questionCode: string) => `form kanıtı · ${questionCode}`,
    // TODO-EVIDENCE-03 — dosya bazlı saklama seçimi
    retentionLabel: "Saklama",
    retentionSaveFailed: "Saklama politikası kaydedilemedi",
    retentionSaved: "Saklama politikası güncellendi",
  },
  retention: {
    system: "sistem",
    keep: "süresiz",
    days: (n: number) => `${n.toString()} gün`,
  },
  scan: {
    purged: "SİLİNDİ — saklama süresi doldu",
    pending: "TARANIYOR",
    clean: "temiz",
    infected: "ENGELLENDİ — silindi",
    quarantined: "ENGELLENDİ — silindi",
    error: "TARAMA HATASI",
    errorHint: "Tarama tamamlanamadı; sistem 10 dakikada bir yeniden dener",
  },
  unlinkDialog: {
    title: "Bağı kaldır",
    body: "Yalnız bu hücreyle olan bağ kalkar; dosya müşterinin kanıt havuzunda kalır.",
    confirm: "Bağı kaldır",
  },
  picker: {
    kicker: "KANIT BAĞLA",
    title: "Hangi hücrelere bağlansın?",
    description:
      "Aynı dosya birden çok gösterge × yıl hücresine bağlanabilir. Varsayılan: açık hücre; aynı kategorideki göstergeler önerilir.",
    sameCategory: "Aynı kategoridekileri seç",
    clearAll: "Temizle",
    selectedCount: (n: number) => `${n.toString()} hücre seçili`,
    confirm: "Bağla",
    locatorLabel: "Konum (isteğe bağlı)",
    locatorSheet: "Sayfa",
    locatorCell: "Hücre",
    locatorPage: "Sayfa no",
    searchIndicators: "Gösterge ara…",
  },
  history: {
    title: "Değişiklik geçmişi",
    empty: "Bu hücre henüz kaydedilmedi",
    lastUpdate: "Son güncelleme",
    version: "sürüm",
    by: "kim",
    you: "siz",
    internal: "danışman",
    client: "müşteri",
    source: "kaynak",
    sourceKinds: {
      manual: "elle giriş",
      import: "içe aktarma",
      client: "müşteri girişi",
      api: "API",
    },
    workflow: "onay",
    note: "Not",
    clarificationNote: "Açıklama isteği",
    noVersions: "Her değişiklik yeni sürüm olarak saklanır; silme yok.",
  },
  reported: {
    badge: "RAPORLANAN",
    pinnedBadge: "SABİT",
    badgeTitle: "Dosyadan gelen (raporlanan) değer",
    pinnedTitle: "Raporlanan değer sabitlendi — hesap yerine bu kullanılır",
    title: "Raporlanan değer",
    enter: "Raporlanan değer gir…",
    change: "Raporlanan değeri değiştir…",
    reportedLabel: "raporlanan",
    computedLabel: "hesap",
    mismatch: "fark",
    noMismatch: "hesapla aynı",
    sourceFile: "kaynak",
    sourceLoading: "kaynak dosya aranıyor…",
    noSource: "kaynak dosya bağlı değil",
    pin: "Sabitle",
    unpin: "Sabiti kaldır",
    pinHint: "Sabitlenince rapora her zaman raporlanan değer gider; hesap değişse bile.",
    unpinHint: "Sabit kaldırılınca hesap yapılabiliyorsa hesaplanan değer kullanılır.",
    usedBecauseNoCalc: "Hesap yapılamadığı için raporlanan değer kullanılıyor.",
    pinFailed: "Sabitleme kaydedilemedi",
    close: "Kapat",
  },
} as const;
